<template>
    <div>
        <button class="btn btn-primary" @click.prevent="" v-if="loading" disabled="disabled">
            <div class="spinner-border text-warning me-2" role="status">
                <span class="sr-only">Loading...</span>
            </div>
            Export
        </button>
        <button class="btn btn-primary" @click.prevent="doExport" v-else>Export</button>
    </div>
</template>
<script>
import {mapActions} from "vuex";
import moment from "moment";

export default {
    name: 'ExportOrder',
    data() {
        return {
            loading: false
        }
    },
    methods: {
        ...mapActions('order', [
            'export',
        ]),
        doExport() {
            this.loading = true;

            //

            setTimeout(() => {

                    this.export().then((response) => {
                    let fileLink = document.createElement('a');
                    fileLink.href = response;
                    fileLink.setAttribute('download', 'export-commande.xlxs');
                    document.body.appendChild(fileLink);

                    fileLink.click();

                }).finally(() => {

                        this.loading = false;
                    })






            }, 1000)

        },
    }
}
</script>
